import { render, staticRenderFns } from "./trafficPoolDeductionRecord.vue?vue&type=template&id=17716d0f&"
import script from "./trafficPoolDeductionRecord.vue?vue&type=script&lang=js&"
export * from "./trafficPoolDeductionRecord.vue?vue&type=script&lang=js&"
import style0 from "./trafficPoolDeductionRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports